import { useMemo, useState } from 'react';
import { PopupMarkets } from '../map/popups/PopupMarkets';
import { PopupTrades } from '../map/popups/PopupTrades';
import { PopupPointConstraints } from '../map/popups/PopupPointConstraint';
import { PointToCapacityComponent } from '../capacityComponents/PointToCapacityComponent';
import { PointToPriceComponent } from '../priceComponents/PointToPriceComponent';
import { CloseIcon, EditIcon } from '@iconicicons/react';
import { PointSelectorModal } from '../points/PointSelectorModal';

/**
 *
 * @typedef {{
 *  lockedTsps: number[];
 *  points: import('../services/edgeApi').Point[];
 *  editable?: boolean;
 *  onRemovePoint?: (pointId: number) => void;
 *  onEditPoint?: (pointId: number) => void;
 *  onAddPoint?: (pointId: number) => void;
 *  onSelectPoint?: (pointId: number) => void;
 * }} NodePointsProps
 */

/**
 *
 * @type {React.FC<NodePointsProps>}
 */
export const NodePoints = ({
  lockedTsps,
  points = [],
  editable = false,
  onRemovePoint,
  onEditPoint,
  onAddPoint,
  onSelectPoint,
}) => {
  const [openPoint, setOpenPoint] = useState(null);
  const [isAddingPoint, setIsAddingPoint] = useState(false);

  return (
    <>
      <h6 className="text-center">Click a location to open details</h6>
      {editable && (
        <div className="d-grid gap-2">
          <button
            className="btn btn-secondary"
            onClick={() => setIsAddingPoint(true)}
          >
            Add point
          </button>
        </div>
      )}
      <ul className="list-group list-group-flush gap-2 mt-2">
        {points.filter(Boolean).map((point) => (
          <li
            key={point.id}
            className="list-group-item bg-light p-0 ps-2 rounded-start border-5 border-primary border-bottom-0 border-top-0 border-end-0"
          >
            <div className="d-flex">
              <h6
                key={point.id}
                className="fw-bold float-start flex-fill align-text-top lh-lg me-2"
                role="button"
                onClick={() => {
                  onSelectPoint?.(point.id);
                  setOpenPoint(point.id === openPoint ? null : point.id);
                }}
              >
                {point.name} -{' '}
                {point.receipt_zone_name || point.delivery_zone_name}{' '}
                {editable && (
                  <>
                    <span className="float-end gap-2">
                      <EditIcon
                        onClick={() => {
                          onEditPoint?.(point.id);
                          return false;
                        }}
                      />
                      <CloseIcon
                        onClick={() => {
                          onRemovePoint?.(point.id);
                          return false;
                        }}
                      />
                    </span>
                  </>
                )}
              </h6>
            </div>
            <div style={point.id === openPoint ? {} : { display: 'none' }}>
              <PopupMarkets pointId={point.id} />
              <PopupTrades pointId={point.id} />
              <PopupPointConstraints pointId={point.id} tspId={point.tsp_id} />
              <PointToCapacityComponent pointId={point.id} />
              <PointToPriceComponent pointId={point.id} />
            </div>
          </li>
        ))}
      </ul>
      <PointSelectorModal
        isOpen={isAddingPoint}
        onClose={() => setIsAddingPoint(false)}
        size="lg"
        lockedTsps={lockedTsps}
        onSelect={(point) => {
          onAddPoint?.(point.id);
          setIsAddingPoint(false);
        }}
      />
    </>
  );
};
